import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { ErrorService, SplittypayError } from 'src/app/core/error.service';
import { StoreMembership, StoreMembershipsService } from 'src/app/core/store-memberships.service';
import { ERROR_STORE_MEMBERHIPS_NOT_FOUND_CODE } from 'src/app/shared/constants/operationals';

@Component({
  selector: 'app-sellers-stores-dialog',
  templateUrl: './sellers-stores-dialog.component.html',
  styleUrls: ['./sellers-stores-dialog.component.scss'],
})
export class SellersStoresDialogComponent {
  is_membership_list_running: boolean = false;
  seller_id?: string;
  store_memberships?: StoreMembership[];

  constructor(
    private dialog_ref: MatDialogRef<SellersStoresDialogComponent>,
    @Inject(MAT_DIALOG_DATA) data: any,
    private store_memberships_service: StoreMembershipsService,
    private error_service: ErrorService,
  ) {
    this.seller_id = data.seller_id;
  }

  ngOnInit(): void {
    if (this.seller_id) {
      this.listStoreMemberships(this.seller_id);
    }
  }

  onCloseClick(): void {
    this.dialog_ref.close();
  }

  listStoreMemberships(seller_id: string): void {
    this.is_membership_list_running = true;
    this.store_memberships_service.listStoreMembershipsBySellerId(seller_id).subscribe({
      next: response => {
        this.store_memberships = response.data;
        this.is_membership_list_running = false;
      },
      error: error => {
        const processed_error: SplittypayError = this.error_service.preProcessApiError(error);

        if (processed_error.code == ERROR_STORE_MEMBERHIPS_NOT_FOUND_CODE) {
          this.store_memberships = [];
        } else {
          this.dialog_ref.close({ error: processed_error });
        }

        this.is_membership_list_running = false;
      },
    });
  }
}
